import api from '../token';

export const MaisVendidos = async () => {
  try {
    const response = await api.post('/maisVendido');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

